import {SearchCriteria} from "./SearchCriteria";

export class PlanTemplateSearchCriteria extends SearchCriteria {
  query?: string;
  fleetwork?: boolean;
  parkGroupIds?: string[];
  campaignIds?: string[];
  customerIds?: number[];
  returnDeleted?: boolean;
  assignedOnly?: boolean;
}
